import React, { useEffect } from 'react';
import axios from 'axios';
import getConfig from 'next/config';

const subscribe = ({ formId, metaData }) => {
  const { publicRuntimeConfig } = getConfig();
  const {
    klaviyoSignupFormWomen,
    klaviyoSignupFormMen,
    klaviyoSignupFormKids,
    klaviyoSignupFormEmbed,
  } = publicRuntimeConfig;
  if (
    formId === klaviyoSignupFormWomen ||
    formId === klaviyoSignupFormMen ||
    formId === klaviyoSignupFormKids ||
    formId === klaviyoSignupFormEmbed
  ) {
    axios.post('/api/newsletter/subscribe', { email: metaData.$email });
  }
};

export const Klaviyo = () => {
  useEffect(() => {
    const handleKlaviyoForm = e => {
      if (e.detail.type === 'open') {
        // guardian event?
      }
      if (e.detail.type === 'submit') {
        subscribe(e.detail);
      }
    };

    window.addEventListener('klaviyoForms', handleKlaviyoForm);
    return () => window.removeEventListener('klaviyoForms', handleKlaviyoForm);
  }, []);
  return <></>;
};
